import React from 'react';
import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  codeBlockPlugin,
  codeMirrorPlugin,
  CreateLink,
  diffSourcePlugin,
  DiffSourceToggleWrapper,
  headingsPlugin,
  imagePlugin,
  InsertCodeBlock,
  InsertImage,
  InsertThematicBreak,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  ListsToggle,
  markdownShortcutPlugin,
  MDXEditor,
  quotePlugin,
  thematicBreakPlugin,
  toolbarPlugin,
  UndoRedo
} from "@mdxeditor/editor";

import '@mdxeditor/editor/style.css';

const ContentEditor = ({content = '', onChange}) => {
  // Character and word counts calculation
  const characterCount = content?.length || 0;
  const wordCount = content?.trim() ? content.trim().split(/\s+/).filter(Boolean).length : 0;

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Content</h3>
      </div>

      <div className="border border-input rounded-lg overflow-hidden bg-background">
        <MDXEditor
          className="min-h-[400px] md:min-h-[500px]"
          markdown={content}
          onChange={onChange}
          placeholder="Start writing your post here..."
          contentEditableClassName="text-foreground max-w-none min-h-[400px] md:min-h-[500px] p-4 md:p-6"
          plugins={[
            headingsPlugin(),
            listsPlugin(),
            quotePlugin(),
            thematicBreakPlugin(),
            markdownShortcutPlugin(),
            linkPlugin(),
            linkDialogPlugin(),
            // 1. Enable Image plugin (supports URL & drag-and-drop file upload)
            imagePlugin({
              /*TODO: enable drag-grop imgs*/
              // imageUploadHandler: handleImageUpload,
            }),
            // 2. Enable Source Mode plugin
            diffSourcePlugin({
              readOnlyDiff: true,
              viewMode: 'rich-text', // Options: 'rich-text' | 'source'
            }),
            codeBlockPlugin({defaultCodeBlockLanguage: 'js'}),
            codeMirrorPlugin({
              codeBlockLanguages: {
                js: 'JavaScript',
                css: 'CSS',
                html: 'HTML',
                ts: 'TypeScript',
                json: 'JSON'
              }
            }),
            toolbarPlugin({
              toolbarContents: () => (
                // DiffSourceToggleWrapper adds the "Rich Text / Source" toggle switch on the right
                <DiffSourceToggleWrapper>
                  <UndoRedo/>
                  <BoldItalicUnderlineToggles/>
                  <BlockTypeSelect/>
                  <ListsToggle/>
                  <CreateLink/>
                  <InsertImage/> {/* Button to insert image via URL or upload */}
                  <InsertCodeBlock/>
                  <InsertThematicBreak/>
                </DiffSourceToggleWrapper>
              )
            })]}
        />
      </div>

      <div className="mt-4 flex items-center justify-between text-xs text-muted-foreground">
        <span>{characterCount} characters</span>
        <span>{wordCount} words</span>
      </div>
    </div>
  );
};

export default ContentEditor;